import { render, staticRenderFns } from "./SyncResourceList.vue?vue&type=template&id=7e753dd0&scoped=true&"
import script from "./SyncResourceList.vue?vue&type=script&lang=js&"
export * from "./SyncResourceList.vue?vue&type=script&lang=js&"
import style0 from "./SyncResourceList.vue?vue&type=style&index=0&id=7e753dd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e753dd0",
  null
  
)

export default component.exports